import { useQuery } from "react-query";
import { API_KEY_GET_AFFILIATE_PROGRAMS } from "../utils";
import { getProgramsList } from "../api";

export const useGetAffiliatePrograms = (params) => {
  return useQuery([API_KEY_GET_AFFILIATE_PROGRAMS, params], () =>
    getProgramsList(params)
  );
};
